import { escapeHtml } from '../../src/react/helpers/utils';

const DEFAULT_ACTION = 'click->case-experience--button-action#handleClick';

const BUTTON_VARIANT_CLASSES = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
};

export function renderCaseExperienceAquiButtonHtml({
  label,
  action = DEFAULT_ACTION,
  extraClass = '',
  type = 'button',
  variant = 'primary',
} = {}) {
  const safeLabel = escapeHtml(String(label ?? ''));
  const variantClass = BUTTON_VARIANT_CLASSES[variant] || BUTTON_VARIANT_CLASSES.primary;
  const classes = ['btn', variantClass, extraClass].filter(Boolean).join(' ');
  const actionAttr = action ? ` data-action="${action}"` : '';

  return `<button type="${type}" class="${classes}" aria-label="${safeLabel}"${actionAttr}><span class="btn-label">${safeLabel}</span></button>`;
}
